const KEY = "qb_cart";

const getItemKey = (item) => item?.cartLineId || item?._id;
const isSameCartItem = (item, payload) =>
  getItemKey(item) === getItemKey(payload) ||
  (item?._id && payload?._id && item._id === payload._id);

const load = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]")
      .map((item, index) => ({
        ...item,
        cartLineId: item.cartLineId || `${item._id || "cart-item"}-${index}`,
      }))
      .reduce((items, item) => {
        const existingIndex = items.findIndex(
          (existingItem) =>
            existingItem?._id && item?._id && existingItem._id === item._id,
        );

        if (existingIndex >= 0) {
          items[existingIndex] = {
            ...items[existingIndex],
            ...item,
            cartLineId: getItemKey(items[existingIndex]),
          };
          return items;
        }

        return [...items, item];
      }, []);
  } catch {
    return [];
  }
};

const save = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
};

const INIT = { items: load(), isOpen: false };

const cartReducer = (state = INIT, action) => {
  switch (action.type) {
    case "CART_ADD_ITEM": {
      const payload = {
        ...action.payload,
        cartLineId:
          action.payload.cartLineId || `${action.payload._id}-${Date.now()}`,
      };
      const exists = state.items.find((i) => isSameCartItem(i, payload));
      const items = exists
        ? state.items.map((i) =>
            isSameCartItem(i, payload)
              ? { ...i, ...payload, cartLineId: getItemKey(i) }
              : i,
          )
        : [...state.items, payload];
      save(items);
      return { ...state, items, isOpen: true };
    }
    case "CART_REMOVE_ITEM": {
      const items = state.items.filter((i) => getItemKey(i) !== action.payload);
      save(items);
      return { ...state, items };
    }
    case "CART_UPDATE_ITEM": {
      const items = state.items.map((i) =>
        getItemKey(i) === getItemKey(action.payload)
          ? { ...i, ...action.payload }
          : i,
      );
      save(items);
      return { ...state, items };
    }
    case "CART_CLEAR":
      save([]);
      return { ...state, items: [] };
    case "CART_OPEN":
      return { ...state, isOpen: true };
    case "CART_CLOSE":
      return { ...state, isOpen: false };
    default:
      return state;
  }
};

export default cartReducer;
